/**
 * The deferred class based on native Promise.
 */
export class NativeDeferred<T> {
    /**
     * The native promise.
     */
    public promise: Promise<T>;

    /**
     * Resolve callback of the deferred object.
     */
    public resolve: (value?: T | PromiseLike<T>) => void;

    /**
     * Reject callback of the deferred object.
     */
    public reject: (reason?: any) => void;

    /**
     * Is fulfilled tracked status.
     */
    public isFulfilled = false;

    /**
     * Is pending tracked status.
     */
    public isPending = true;

    /**
     * Initializes a new instance of the NativeDeferred class.
     */
    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = (data) => {
                resolve(data); this.isFulfilled = true; this.isPending = false;
            };
            this.reject = (error) => {
                reject(error); this.isPending = false;
            };
        });
    }
}

/**
 * Native Q to attach on native Promise.
 */
export class NativeQ {
    /**
     * Create native deferred object.
     */
    public static defer<T>(): NativeDeferred<T> {
        return new NativeDeferred<T>();
    }

    /**
     * Create rejected native deferred object.
     */
    public static rejected<T>(reason?: any): Promise<T> {
        const deferred = new NativeDeferred<T>();
        deferred.reject(reason);
        return deferred.promise;
    }

    /**
     * Create resolved native deferred object.
     */
    public static resolved<T>(data?: T): Promise<T> {
        const deferred = new NativeDeferred<T>();
        deferred.resolve(data);
        return deferred.promise;
    }
}
